import { formatEuro } from './formatEuro';

/**
 * Ποσό στη μορφή της εμφάνισης της συσκευής: κλασική «€2.60» (ακριβώς όπως πάντα), «Νέα
 * εμφάνιση» «2,60 €». Διαβάζει την κλάση .look-v2 του <html> (ThemeContext) τη στιγμή της
 * ζωγραφιάς, ώστε να μπαίνει σε κάθε οθόνη χωρίς να περνά το look από παντού. Μόνο για εμφάνιση.
 */
export const formatMoney = (amount: number): string => {
  const n = Number(amount);
  const v2 = typeof document !== 'undefined' && document.documentElement.classList.contains('look-v2');
  return v2 ? formatEuro(n) : `€${n.toFixed(2)}`;
};
